import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../Services/apiService";
import { error } from "jquery";

export const AddObjectivesActivities = createAsyncThunk("ObjectivesActivities/AddObjectivesActivities",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/ObjectivesActivities/AddObjectivesActivities", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const DeleteObjectivesActivities = createAsyncThunk("ObjectivesActivities/DeleteObjectivesActivitiesById",
    async (parameters, { rejectWithValue }) => {
        try {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/ObjectivesActivities/DeleteObjectivesActivitiesById", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data
        } catch {
            return rejectWithValue(error.message);
        }
    }
)



export const GetOneObjectivesActivities = createAsyncThunk("ObjectivesActivities/GetObjectivesActivitiesById",
    async (parameters, { rejectWithValue }) => {
        try {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/ObjectivesActivities/GetObjectivesActivitiesById", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data
        } catch {
            return rejectWithValue(error.message);
        }
    }
)



export const EditOneObjectivesActivities = createAsyncThunk("ObjectivesActivities/EditObjectivesActivities",
    async (parameters, { rejectWithValue }) => {
        try {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/ObjectivesActivities/EditObjectivesActivities", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data
        } catch {
            return rejectWithValue(error.message);
        }
    }
)


export const GetObjectivesActivities = createAsyncThunk("ObjectivesActivities/GetObjectivesActivities",
    async (parameters, { rejectWithValue }) => {
        try {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/ObjectivesActivities/GetObjectivesActivitiesListByAppGuid", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data
        } catch {
            return rejectWithValue(error.message);
        }
    }
)

// export const GetItemType = createAsyncThunk("ObjectivesActivities/GetItemType",
//     async (parameters, { rejectWithValue }) => {
//         try {
//             await initializeApiClient();
//             const apiClient = await getApiClient();
//             const response = await apiClient.post(
//                 "api/DropDowns/GetAllBI_AB_ItemType", parameters
//             );
//             // Extract data from the response object
//             const data = response.data.result; // Assuming response has a "data" field

//             return data; // Return the extracted data
//         } catch {
//             return rejectWithValue(error.message);
//         }
//     }
// )

const ObjectivesActivitiesReducer = createSlice({
    name: "ObjectivesActivities",
    initialState: {
        addObjectivesActivities: {},
        lodingAddObjectivesActivities: false,
        errorAddObjectivesActivities: null,

        deleteObjectivesActivities: {},
        lodingdeleteObjectivesActivities: false,
        errorAddObjectivesActivities: null,

        ObjectivesActivities: {},
        lodingObjectivesActivities: false,
        errorObjectivesActivities: null,

        editObjectivesActivities: {},
        lodingeditObjectivesActivities: false,
        erroreditObjectivesActivities: null,

        ObjectivesActivitiesList: {},
        lodingObjectivesActivitiesList: false,
        errorObjectivesActivitiesList: null,

        // ItemTypeList: {},
        // lodingItemTypeList: false,
        // errorItemTypeList: null
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(AddObjectivesActivities.pending, (state, action) => {
                state.lodingAddObjectivesActivities = true;
                state.addObjectivesActivities = action.payload;
                state.errorAddObjectivesActivities = null;
            })
            .addCase(AddObjectivesActivities.fulfilled, (state, action) => {
                state.lodingAddObjectivesActivities = false;
                state.addObjectivesActivities = action.payload; // Assuming payload has the desired data
            })
            .addCase(AddObjectivesActivities.rejected, (state, action) => {
                state.lodingAddObjectivesActivities = false;
                state.addObjectivesActivities = action.payload;
            })
        ////////////////////////////////////////////////////////
        builder
            .addCase(DeleteObjectivesActivities.pending, (state, action) => {
                state.lodingdeleteObjectivesActivities = true;
                state.deleteObjectivesActivities = action.payload;
                state.errorAddObjectivesActivities = null;
            })
            .addCase(DeleteObjectivesActivities.fulfilled, (state, action) => {
                state.lodingdeleteObjectivesActivities = false;
                state.deleteObjectivesActivities = action.payload; // Assuming payload has the desired data
            })
            .addCase(DeleteObjectivesActivities.rejected, (state, action) => {
                state.lodingdeleteObjectivesActivities = false;
                state.errorAddObjectivesActivities = action.payload;
            })
        /////////////////////////////////////////////////////////////
        builder
            .addCase(GetOneObjectivesActivities.pending, (state, action) => {
                state.lodingObjectivesActivities = true;
                state.ObjectivesActivities = action.payload;
                state.errorObjectivesActivities = null;
            })
            .addCase(GetOneObjectivesActivities.fulfilled, (state, action) => {
                state.lodingObjectivesActivities = false;
                state.ObjectivesActivities = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetOneObjectivesActivities.rejected, (state, action) => {
                state.lodingObjectivesActivities = false;
                state.errorObjectivesActivities = action.payload;
            })
        ////////////////////////////////////////////////////////////
        builder
            .addCase(EditOneObjectivesActivities.pending, (state, action) => {
                state.lodingeditObjectivesActivities = true;
                state.editObjectivesActivities = action.payload;
                state.errorObjectivesActivities = null;
            })
            .addCase(EditOneObjectivesActivities.fulfilled, (state, action) => {
                state.lodingeditObjectivesActivities = false;
                state.editObjectivesActivities = action.payload; // Assuming payload has the desired data
            })
            .addCase(EditOneObjectivesActivities.rejected, (state, action) => {
                state.lodingeditObjectivesActivities = false;
                state.erroreditObjectivesActivities = action.payload;
            })
            /////////////////////////////////////////////////////////////////////
            builder
            .addCase(GetObjectivesActivities.pending, (state, action) => {
                state.lodingObjectivesActivitiesList = true;
                state.ObjectivesActivitiesList = action.payload;
                state.errorObjectivesActivitiesList = null;
            })
            .addCase(GetObjectivesActivities.fulfilled, (state, action) => {
                state.lodingObjectivesActivitiesList = false;
                state.ObjectivesActivitiesList = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetObjectivesActivities.rejected, (state, action) => {
                state.lodingObjectivesActivitiesList = false;
                state.errorObjectivesActivitiesList = action.payload;
            })
            /////////////////////////////////////////////////////////////////////
            // builder
            // .addCase(GetItemType.pending, (state, action) => {
            //     state.ItemTypeList = true;
            //     state.ItemTypeList = action.payload;
            //     state.errorObjectivesActivitiesList = null;
            // })
            // .addCase(GetItemType.fulfilled, (state, action) => {
            //     state.ItemTypeList = false;
            //     state.ItemTypeList = action.payload; // Assuming payload has the desired data
            // })
            // .addCase(GetItemType.rejected, (state, action) => {
            //     state.ItemTypeList = false;
            //     state.errorItemTypeList = action.payload;
            // })
    }
})

export default ObjectivesActivitiesReducer.reducer